import "../../components/Suggestionbox/suggest.css";
import { useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Col, Row, Card } from "react-bootstrap";
import ClearIcon from "@mui/icons-material/Clear";
import PersonalImage from "../../helpers/fileUpload";
import { images } from "../../constants";
import { useState } from "react";
import { publishImage } from "../../helpers/imageupload";
import { useDropzone } from "react-dropzone";
import { getAsset } from "../../helpers/helper";
import url from "../../config/axios";
import { FailedNotify, SuccessNotify } from "../../constants/tostify";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
const Reportbox = ({
  lgshowreport,
  setLgShowreport,
  setCreateShop,
  shopid,
  createShop,
}) => {

  const location = useLocation();

  const pathname = location.pathname === `/services-online/${shopid}` ? "serviceId" : "shopId";


  const { name } = useSelector((state) => state.user);
  const [shopOwner, setShopOwner] = useState({
    userId: name._id,
    reportType: "",
    description: "",
    image: [],
    email: name.email,
    imageUrl: name.imageUrl,
    fullname: name.fullname
  });



  useEffect(() => {
    setShopOwner((prev) => ({
      ...prev,
      [pathname]: shopid ? shopid : "",
    }));
  }, [pathname, shopid]);

  const HandlePost = () => {

    const endpoint = location?.pathname === `/services-online/${shopid}` ? "reportservice/" : "reportshop/";

    url
      .post(endpoint, shopOwner)
      .then(async (res) => {
        if (res.data.message === "Report added successfully") {
          SuccessNotify("Report Send Successfully");
          setLgShowreport(false);
        }
      })
      .catch(() => {
        FailedNotify("Failed to create Try Again!");
        setLgShowreport(false);
      });
  };

  const [displayimg, setDisplayimg] = useState();

  const onDrop = async (acceptedFiles) => {
    try {
      const abc = await publishImage(acceptedFiles);
      setShopOwner((shopOwner) => ({
        ...shopOwner,
        image: abc,
      }));

      setDisplayimg(abc);
    } catch (error) {
      FailedNotify("Failed! Try Again");
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop,
  });

  const ShopHandler = (event) => {
    setShopOwner((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };

  const removeImage = (index) => {
    const updatedImages = [...displayimg];
    updatedImages.splice(index, 1);
    setDisplayimg(updatedImages);
  };

  return (
    <>
      <Modal
        size="lg"
        show={lgshowreport}
        onHide={() => setLgShowreport(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        centered
        scrollable
        dialogClassName="shop-owner-report-modal"
      >
        <Modal.Header closeButton className="bg-blue-lg">
          <Modal.Title id="example-modal-sizes-title-lg">
            <h5 className="text-center text-white">Report to Shop Owner</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {" "}
          <div className="col-11 mx-auto">
            <h6>Write a Problem to Continue</h6>
            <p className="shop-profile-para">Report Title</p>
            <Col lg="4">
              <input
                name="reportType"
                onChange={(e) => {
                  ShopHandler(e);
                }}
                placeholder="Type Your Report Title.."
                className="input-style"
              />
            </Col>
            <label
              for="exampleFormControlTextarea1"
              className="form-label mt-2 font-weight-bold font_11"
            >
              Report Description*
            </label>
            <textarea
              onChange={(e) => {
                ShopHandler(e);
              }}
              name="description"
              className="form-control input-style"
              id="exampleFormControlTextarea1"
              rows="8"
              style={{ border: "1px solid #C4C4C4" }}
              placeholder="Type your message here.."
            ></textarea>
            <div className="row mt-2 report-shop-upload">
              <div className="col-8 col-lg-8 col-md-12 ps-3 report-shop-upload-files">
                <h6>Add Screenshots*</h6>
                <div className="row mt-2">
                  <Col lg="12" className="me-auto">
                    <Row>
                      <Col lg={3} md={3} className="mt-2 ms-1">
                        <Card
                          style={{ width: "6rem", height: "6rem" }}
                          {...getRootProps()}
                          className="dropzone"
                        >
                          <Card.Img
                            className="imet-fit"
                            src={images.AddImage}
                          />
                          <Card.Body>
                            <input
                              type="file"
                              id="file"
                              style={{ display: "none" }}
                              {...getInputProps()}
                              multiple
                            />
                          </Card.Body>
                        </Card>
                      </Col>
                      {displayimg?.length > 0 && (
                        <Col lg={8} md={8} className=" mt-1 d-flex">
                          {displayimg.map((image, index) => (
                            <Card
                              className="me-2 mt-1"
                              style={{
                                width: "6rem",
                                height: "6rem",
                                border: "2px solid",
                              }}
                            >
                              <Card.Img
                                className="imet-fit upload-img mt-0"
                                src={getAsset(image)}
                                alt=""
                                crossOrigin="anonymous"
                              />
                              <div
                                className="close-btnone"
                                onClick={() => removeImage(index)}
                              >
                                <ClearIcon />
                              </div>
                            </Card>
                          ))}
                        </Col>
                      )}
                    </Row>
                  </Col>
                </div>
              </div>

              <div className="report-shop-modal-actions">
                <button
                  className="btn-red-sm"
                  onClick={() => setLgShowreport(false)}
                >
                  Cancel
                </button>
                <button className="btn-blue-sm" onClick={HandlePost}>
                  Send
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Reportbox;
